import { useQueryQuizzes } from '@src/api/queries/quizzes.queries';
import { QuizPage, QuizzesPage } from '@src/pages';

export const QuizRoute = () => {
  const { variant, isError } = useQueryQuizzes();
  return !variant || isError ? <QuizPage /> : <QuizzesPage />;
};
